<template>
  <v-card @mouseover="hover = true" @mouseleave="hover = false" :class="hover ? 'px-3 elevation-10 pointer' : 'px-3 elevation-3 pointer'" @click="$emit('clicked')" >
    <v-layout row wrap align-center>
      <v-flex xs5 class="px-2">
        <div style="position:relative;">
          <v-img :src="offer.image"></v-img>
          <span class="discount" style="z-index:100;">
            <h4>{{ offer.discount }} %</h4>
          </span>
        </div>
      </v-flex>
      <v-flex xs7 class="px-0">
        <p class="mb-0" style="font-size:11px;">{{service.serviceName}}</p>
        <h2 class="font-weight-light primary--text">{{offer.service_item.description}}</h2>
      </v-flex>
      <v-flex xs12 class="pt-0">
        <p class="mb-0">
          <small class="primary--text">Solicitado el</small>
          <br> 
          {{$moment(item.created_at).format('ddd DD MMM YYYY | HH:mm')}}
          </p>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    offer: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      service: '',
      hover: false
    }
  },
  mounted() {
    this.service = this.services.find(el => el.serviceItemId === this.offer.service_item.id)
  }
}
</script>
<style scoped>
.discount {
  background-color: red;
  color: white;
  display: inline-block;
  padding: 4px 10px;
  position: absolute;
  top: 20px;
  right: 0;
}
.discount h2 {
  font-weight: 900;
}
.pointer {
  cursor: pointer;
}
</style>